<template>
  <b-container>
    <b-row class="prices">
      <b-col>
        <div class="animated wow fadeIn">
          <h3 id="cennik">Cennik</h3>
          <h5 class="text-primary">
            Nacinarka z 10 uchwytami
          </h5>
          <b-list-group>
            <!-- <b-list-group-item><b>UR43</b> : <strike>2700 pln</strike><b style="color:red"> PROMOCJA! </b> 2300 pln <i>(netto)</i></b-list-group-item> -->
            <b-list-group-item><b>NOBUK 53</b> : <b style="color:gray;text-decoration:line-through;">3500 pln</b> <b style="color:red" class="animated wow flash"> PROMOCJA !!! - 3200 pln </b>  <i>(netto)</i></b-list-group-item>
          </b-list-group>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Prices'
}
</script>

<style lang="scss" scoped>
@import 'node_modules/bootstrap/scss/functions';
@import 'node_modules/bootstrap/scss/variables';

h3 {
  font-size: 60px;
  font-weight: bold;
  text-align: left;
  color: #777;
  margin-bottom: 20px;
  margin-top: 15px;
  text-transform: uppercase;
  @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    font-size: 36px;
  }
}

p {
  font-size: 22px;
  color: #777;
  line-height: 24px;
  text-align: justify;
}
h5 {
  font-size: 26px;
  font-weight: 500;
  margin-bottom: 25px;
  line-height: 28px;
}
.btn {
  margin-top: 30px;
}
</style>
